import { Box } from '@mui/material';

import DataFooterButtons from '@/features/DataHub/components/ExportDrawer/DataFooterButtons';
import ImageFooterButtons from '@/features/DataHub/components/ExportDrawer/ImageFooterButtons';
import { DATAHUB_SPACING_LG } from '@/features/DataHub/constants/ui';
import { useExportSettings } from '@/features/DataHub/modules/Export/context/ExportSettingsContext';
import { ExportTypes } from '@/features/DataHub/modules/Export/types';

const FooterButtons = () => {
  const { exportSettings } = useExportSettings();
  return (
    <Box
      sx={{
        minHeight: '96px',
        width: '100%',
        backgroundColor: 'background.main',
        borderTop: '1px solid',
        borderColor: 'info.dark',
        p: DATAHUB_SPACING_LG,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: DATAHUB_SPACING_LG,
        '& > *': {
          flex: 1
        }
      }}
    >
      {exportSettings.exportType === ExportTypes.DATA && <DataFooterButtons />}
      {exportSettings.exportType === ExportTypes.IMAGE && exportSettings.exportSubType && (
        <ImageFooterButtons />
      )}
    </Box>
  );
};

export default FooterButtons;
